import EscalationMatrixBanner from './EscalationMatrixBanner';
import EscalationMatrixSection from './EscalationMatrixSection';

function EscalationMatrix() {
  return (
    <div>
      <EscalationMatrixBanner />
      <EscalationMatrixSection />
    </div>
  );
}

export default EscalationMatrix;